import { render, staticRenderFns } from "./modalHistorialCupo.vue?vue&type=template&id=2b5f79fc&"
import script from "./modalHistorialCupo.vue?vue&type=script&lang=js&"
export * from "./modalHistorialCupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports